import ko from "knockout";
import apiCore from "services/apiCore";

const sentimentsList = ko.observableArray();
const DEFAULT_PAGE_NUMBER = 1;
const DEFAULT_PAGE_SIZE = 25;

const updateSentimentsList = function (event) {
    if (!event) {
        return;
    }

    const payload = event.data;
    if (payload.key == "transcriptUIAnnotations") {
        sentimentsList(payload.transfer);
    }
};

const resetSentimentsList = function () {
    sentimentsList([]);
};

const getConversationMetrics = function (conversationId) {
    return apiCore.v2.get(
        "/speechandtextanalytics/conversations/" + conversationId
    );
};

window.addEventListener("message", updateSentimentsList);

/**
 * Get the list of conversation categories associated with the conversation ID.
 * @param {String} conversationId the conversation ID to look up conversation categories with
 * @param {number} pageNumber the page number to get detected categories from
 * @param {number} pageSize the number of categories that each page of results should contain
 */
const getConversationCategories = async function (
    conversationId,
    pageNumber = DEFAULT_PAGE_NUMBER,
    pageSize = DEFAULT_PAGE_SIZE
) {
    const queryParameters = [];
    queryParameters.push("pageNumber=" + pageNumber);
    queryParameters.push("pageSize=" + pageSize);

    return apiCore.v2.get(
        "/speechandtextanalytics/conversations/" +
            conversationId +
            "/categories?" +
            queryParameters.join("&")
    );
};

/**
 * Get a list of categories depending on the requested list of ids
 * @param {string} ids a comma-delimited string of requested ids
 */
const batchGetCategories = async function (ids) {
    const queryParameters = [];
    queryParameters.push("ids=" + ids);
    return apiCore.v2.get(
        "/speechandtextanalytics/categories?" + queryParameters.join("&")
    );
};

export default {
    sentimentsList: sentimentsList,
    getConversationMetrics: getConversationMetrics,
    resetSentimentsList: resetSentimentsList,
    getConversationCategories: getConversationCategories,
    batchGetCategories: batchGetCategories,
};
